import { z } from 'zod';
import {
  commercialJobCreateInput,
  commercialJobActivityCreateInput,
} from './commercialJob';
import { quoteCreateInput } from './money';
import { workOrderConfirmInput, workOrderTaskCreateInput } from './workOrder';
import { linkBackorderSupplyInput } from './inventory-reservations';

const delivery = z.object({ clientId: z.string().uuid(), mutationId: z.string().uuid() });
/** Parse the identical writer input, including defaults/dates, then require its saved key. */
export const commercialWriteRecoveryInput = z.discriminatedUnion('action', [
  z
    .object({
      action: z.literal('commercialJob.create'),
      request: commercialJobCreateInput.and(delivery),
    })
    .strict(),
  // Legacy Quote creation does not bind its stored answer to the full request hash.
  z
    .object({
      action: z.literal('quote.create'),
      request: quoteCreateInput
        .and(delivery)
        .and(z.object({ commercialJobId: z.string().uuid() })),
    })
    .strict(),
  z
    .object({
      action: z.literal('workOrder.confirm'),
      request: workOrderConfirmInput.and(delivery),
    })
    .strict(),
  z
    .object({
      action: z.literal('workOrder.taskCreate'),
      request: workOrderTaskCreateInput.and(delivery),
    })
    .strict(),
  z
    .object({
      action: z.literal('inventoryReservations.linkSupply'),
      request: linkBackorderSupplyInput.and(delivery),
    })
    .strict(),
  z
    .object({
      action: z.literal('commercialJob.addActivity'),
      request: commercialJobActivityCreateInput.and(delivery),
    })
    .strict(),
]);
export type CommercialWriteRecoveryInput = z.infer<typeof commercialWriteRecoveryInput>;
export type CommercialWriteRecoveryResult =
  | { status: 'abandoned' }
  | {
      status: 'committed';
      destination: { type: 'commercial_job' | 'quote' | 'work_order'; id: string };
    };
